import React from 'react'

import FormattedDateTime from 'syft-acp-core/components/FormattedDateTime'

import { startMsOf } from './helpers'
import { ShiftOverbookCover, WorkerJobBooking } from './types'

// The per-date cover breakdown shown under "keep the spot" when an overbook backup
// exists. Same list whether there's one shift or several — one experience, not a
// one-liner for the single case and a table for the multi case.
export const CoverPreview = ({
  coverPreview,
}: {
  coverPreview: { booking: WorkerJobBooking; cover: ShiftOverbookCover }[]
}) => (
  <ul className="overbook-cover-preview">
    {coverPreview.map(({ booking, cover }) => (
      <li key={booking.shift_id}>
        {/* @ts-expect-error legacy component types */}
        <FormattedDateTime
          value={startMsOf(booking)}
          format={{ day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }}
        />
        {': '}
        {cover.covered ? (
          <>
            <strong>{cover.worker_name}</strong> may move in
          </>
        ) : (
          'no cover — reopens'
        )}
      </li>
    ))}
  </ul>
)
